<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-09 10:31:47
 * @Description: 关于我们
 -->

<template>
  <div class="m-about-us-wrapper">
    <div class="banner">
      <img src="https://files.jinr.com/jinr-index/img/about-us.png" alt="" v-show="!isParty" />
      <img src="https://files.jinr.com/jinr-index/img/banner-party.png" alt="" v-show="isParty" />
    </div>
    <div class="content-wrapper">
      <div class="slide-warpper">
        <div
          v-for="(item, index) in navList"
          :key="index"
          class="slide-item"
          :class="{ active: activeIndex === index }"
          @click="routerJump(item, index)"
        >
          <span>{{ item.meta.title }}</span>
        </div>
      </div>
      <div class="main-view">
        <!-- <header-banner :title="title" :isParty="isParty"></header-banner> -->
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import mRoutes from '@/router/phone-routes.js';
export default {
  name: 'AboutUs',
  data() {
    return {
      activeIndex: 0
    };
  },
  computed: {
    navList() {
      return mRoutes[3].children;
    },
    title() {
      return this.$route.meta.title;
    },
    routerPath() {
      return window.location.href.split('#/')[1];
    },
    isParty() {
      const reg = /\/m-about-us\/m-party/;
      return reg.test(this.$route.path);
      // return this.$route.path === '/about-us/party/list';
    }
  },
  watch: {
    $route(to) {
      this.locationRouter(to.path);
    }
  },
  created() {
    this.locationRouter();
  },
  methods: {
    routerJump(route, index) {
      this.activeIndex = index;
      this.$router.push({
        path: route.path,
        name: route.name
      });
    },
    locationRouter(path) {
      const routerPath = path ? path : `/${this.routerPath}`;
      this.navList.forEach((item, index) => {
        const tempStr = routerPath.split('/')[2];
        if (item.path === tempStr) {
          this.activeIndex = index;
        }
      });
    }
  }
};
</script>
<style lang="less" scope>
.m-about-us-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .banner {
    overflow: hidden;
    width: 100%;
    height: 2.11rem;
    background-color: #f7f8f9;
    img {
      height: 2.11rem;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .content-wrapper {
    display: flex;
    align-items: flex-start;
    height: calc(100% - 2.11rem);
  }
  .slide-warpper {
    width: 1.56rem;
    height: 100%;
    background-color: #f7f8f9;
    font-size: 0.24rem;
    display: block;
    box-sizing: border-box;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    .slide-item {
      padding: 0 0 0 0.2rem;
      height: 0.84rem;
      line-height: 0.84rem;
      color: #666666;
      span {
        display: inline-block;
        vertical-align: middle;
        line-height: 0.3rem;
      }
    }
    .slide-item.active {
      position: relative;
      color: #333333;
      background: #fff;
    }
  }
  .main-view {
    flex: 1;
    width: 5.94rem;
    height: 100%;
    background: #ffffff;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
    .bank-wrapper {
      padding: 0;
    }
  }
}
</style>
